// Required Modules
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { QRCodeModule } from 'angularx-qrcode';

// Modules
import { Routing } from './core/routing/app.routing';
import { CoreModule } from './core/core.module';
import { TranslationModule } from './translation/translation.module';
// Components
import { AppComponent } from './core/components/app.component';

// Guards
import { AuthGuard } from './auth/services/auth-guard.service';
import { AnonymousGuard } from './auth/services/anonymous-guard.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    Routing,
    BrowserModule,
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 50 }),
    BrowserAnimationsModule,
    QRCodeModule,
    // Custom Modules
    CoreModule,
    TranslationModule.forRoot()
  ],
  providers: [
    AuthGuard,
    AnonymousGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts